import React, { useState, useRef } from 'react';
import axios from 'axios';
import { toast } from 'react-toastify';
import JoditEditor from 'jodit-react';

const NoticesAdd = () => {

    const DisRef = useRef(null)
    const [Dis, setDisContent] = useState('')


    const [errorMessage, setErrorMessage] = useState([]);
    const [dataVulue, setDataVulue] = useState({});
    const refSubmitDis = useRef();


    const [Image, setImage] = useState('');

    const handleImage = (e) => {
        setImage(e.target.files[0])
    }

    const handleSubmitData = event => {
        event.preventDefault();
        refSubmitDis.current.setAttribute("disabled", true);
        setErrorMessage({});

        try {

            const storeData = { ...dataVulue, image: Image, dis: Dis, };

            const config = {
                headers: {
                    'content-type': 'multipart/form-data',
                }
            };
            axios.post(`https://api.velormall.com/api/admin/notice/store`, storeData, config)
                .then(response => {
                    setImage('');
                    setDisContent('');
                    event.target.reset();
                    toast.success(`${response?.data.message}`, {
                        position: "top-right",
                        autoClose: 5000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                        theme: "colored",
                    });
                    refSubmitDis.current.removeAttribute("disabled");
                }).catch((error) => {
                    setErrorMessage(error?.response?.data?.errors)
                    refSubmitDis.current.removeAttribute("disabled");
                });
        } catch (error) {

        }

    }

    const handleInputBlur = event => {
        const value = event.target.value;
        const field = event.target.name;
        const newData = { ...dataVulue };
        newData[field] = value;
        setDataVulue(newData);
    }


    return (
        <>
            <div className="d-flex mb-30 flex-wrap gap-3 justify-content-between align-items-center">
                <h6 className="page-title">Notice add</h6>
                <div className="d-flex flex-wrap justify-content-end gap-2 align-items-center breadcrumb-plugins">
                </div>
            </div>

            <div className="row">
                <div className="col-lg-12 col-md-12 mb-30">
                    <div className="card">
                        <div className="card-body">
                            <form onSubmit={handleSubmitData}>
                                <div className="row">
                                    <div className=" col-md-8 ">
                                        <div className="col-md-12">
                                            <div className="form-group">
                                                <label htmlFor="heading" className="required">Title</label>
                                                <input type="text" className="form-control" name="name" onBlur={handleInputBlur} placeholder='Title' id="heading" />
                                                {errorMessage?.name && (
                                                    <span className="text-danger pt-2">
                                                        {errorMessage?.name?.msg}
                                                    </span>
                                                )}
                                            </div>
                                        </div>

                                        <div className="col-md-12">
                                            <div className="form-group">
                                                <label htmlFor="heading" className="required">Short Description</label>
                                                <textarea name='short_dis' onBlur={handleInputBlur} ></textarea>
                                                {errorMessage?.short_dis && (
                                                    <span className="text-danger pt-2">
                                                        {errorMessage?.short_dis?.msg}
                                                    </span>
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-md-4">
                                        <div className="form-group">
                                            <div className="image-upload">
                                                <div className="thumb">
                                                    <div className="avatar-edit">
                                                        <input type="file" onChange={handleImage} className="profilePicUpload" name="image" id="profilePicUpload0" accept=".jpg,.jpeg,.png" />
                                                        <label htmlFor="profilePicUpload0" className="bg--primary">Choose Image</label>
                                                        <small class="mt-2  ">Supported files: <b>jpeg, jpg, png.</b> Image will be resized into   (width: 1136px  * height: 568px)  </small>
                                                    </div>
                                                    {errorMessage?.image && (
                                                        <span className="text-danger pt-2">
                                                            {errorMessage?.image?.msg}
                                                        </span>
                                                    )}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-md-12">
                                        <div className="form-group">
                                            <label htmlFor="button_one_url" className="required"> Description</label>
                                            <JoditEditor
                                                ref={DisRef}
                                                value={Dis}
                                                height="600"
                                                onChange={(newContent) => setDisContent(newContent)}
                                            />
                                            {errorMessage?.dis && (
                                                <span className="text-danger pt-2">
                                                    {errorMessage?.dis?.msg}
                                                </span>
                                            )}
                                        </div>
                                    </div>


                                </div>

                                <div className="form-group">
                                    <button ref={refSubmitDis} type="submit" className="btn btn-primary w-100 h-45">Submit</button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );



};

export default NoticesAdd;